module.exports = __webpack_public_path__ + "static/media/not-found.cb8463dc.svg";